import ApiService from './ApiService';

export interface BannerData {
    id: number,
    link_img: string,
    value: string
}

class BannerApi extends ApiService {
    constructor() {
        super('banner');
    }

    getBanner() {
        return this.get('');
    }
}

const bannerApi = new BannerApi();
export default bannerApi;
